import _ from 'lodash'
import S3Service from '@/modules/documents/services/S3Service'
import moment from 'moment-timezone'

export default {
  namespaced: true,
  state: () => {
    return {
      dialogUploadWizard: false,
      isUploadingFile: false,
      step: 1,
      steps: [
        { id: 1, title: 'Archivo(s) a Firmar', component: 'UploadFileList' },
        { id: 2, title: 'Firmante(s)', component: 'AddSigners' },
        { id: 3, title: 'Recordatorios', component: 'NotificationSettings' }
      ],
      files: [],
      fileHeaders: [
        { text: '', value: 'active', sortable: false, width: '50'},
        {
          text: 'Nombre',
          value: 'nombre',
          width: '500',
          sortable: false
        },
        { text: 'Eliminar', value: 'actions', sortable: false, width: '80' }
      ],
      selectedItems: [],
      tipoDocumentos: [],
      currentItem: {
        nombre: '',
        descripcion: '',
        clave: '',
        tipoDocumento: null,
        folder: {
          idCarpeta: null
        },
        fechaExpiracion: ''
      },
      isValidStepOne: false,
      expirationDate: null,
      isSetDefaultFolder: false
    }
  },
  mutations: {
    SET_STEP(state, step) {
      state.step = step
    },
    SET_DIALOG_UPLOAD_WIZARD(state, dialog) {
      state.dialogUploadWizard = dialog
    },
    SET_FILES(state, files) {
      state.files = files
    },
    SET_IS_UPLOADING_FILE(state, isUploading) {
      state.isUploadingFile = isUploading
    },
    SET_SELECTED_ITEMS(state, selectedItems) {
      state.selectedItems = selectedItems
    },
    SET_TIPO_DOCUMENTOS(state, tipoDocumentos) {
      state.tipoDocumentos = tipoDocumentos
    },
    SET_CURRENT_ITEM(state, currentItem) {
      state.currentItem = currentItem
    },
    SET_IS_VALID_STEP_ONE(state, isValidStepOne) {
      state.isValidStepOne = isValidStepOne
    },
    SET_IS_SET_DEFAULT_FOLDER(state, isSetDefaultFolder) {
      state.isSetDefaultFolder = isSetDefaultFolder
    },
    SET_EXPIRATION_DATE(state, expirationDate) {
      state.expirationDate = expirationDate
    }
  },
  actions: {
    openUploadWizard({ commit }) {
      commit('SET_DIALOG_UPLOAD_WIZARD', true)
      commit('SET_STEP', 1)
      commit('SET_IS_SET_DEFAULT_FOLDER', false)
    },
    closeUploadWizard({ commit }) {
      commit('SET_DIALOG_UPLOAD_WIZARD', false)
      commit('SET_FILES', [])
      commit('SET_SELECTED_ITEMS', [])
      commit('SET_CURRENT_ITEM', {
        nombre: '',
        descripcion: '',
        clave: '',
        tipoDocumento: null,
        folder: {
          idCarpeta: ''
        },
        fechaExpiracion: ''
      })
      commit('SET_TIPO_DOCUMENTOS', [])
      commit('SET_IS_SET_DEFAULT_FOLDER', false)
    },
    goNext({ commit, state }) {
      if (state.step < state.steps.length) {
        commit('SET_STEP', state.step + 1)
      }
    },
    goBack({ commit, state }) {
      if (state.step > 1) {
        commit('SET_STEP', state.step - 1)
      }
    },
    setFiles({ commit, rootState }, files) {
      let aux = []
      let index = 1
      let rootFolder = {
        idCarpeta: rootState.folderStore.folderRoot
      }

      _.forEach(files, f => {
        const file = f.file

        const item = {
          id: index,
          nombre: file.name,
          descripcion:
            file.name.substr(0, file.name.lastIndexOf('.')) || file.name,
          tipoDocumento: file.tipoDocumento || null,
          clave: file.clave || '',
          numeroPaginas: f.pages,
          tipo: file.type,
          tamanio: file.size,
          hash: f.hash,
          fileData: file,
          presignUrl: null,
          folder: rootFolder,
          fechaExpiracion: moment()
            .add(30, 'days')
            .format('YYYY-MM-DD')
        }

        aux.push(item)

        if (index === 1) {
          let selected = []
          selected.push(item)
          commit('SET_SELECTED_ITEMS', selected)
          commit('SET_CURRENT_ITEM', {
            nombre: item.nombre,
            descripcion: item.descripcion,
            clave: item.clave,
            tipoDocumento: item.tipoDocumento,
            folder: item.folder,
            fechaExpiracion: item.fechaExpiracion
          })
        }

        index = index + 1
      })

      commit('SET_FILES', aux)
    },
    removeFile({ commit, state }, file) {
      const files = state.files
      let aux = []
      let selected = []
      let index = 1

      _.forEach(files, f => {
        if (f.nombre !== file.nombre) {
          const item = {
            id: index,
            nombre: f.nombre,
            descripcion: f.descripcion,
            tipoDocumento: f.tipoDocumento,
            clave: f.clave,
            numeroPaginas: f.numeroPaginas,
            tipo: f.tipo,
            tamanio: f.tamanio,
            hash: f.hash,
            fileData: f.fileData,
            presignUrl: null,
            folder: f.folder,
            fechaExpiracion: f.fechaExpiracion
          }

          aux.push(item)

          if (index === 1) {
            selected.push(item)
          }

          index = index + 1
        }
      })

      if (aux.length === 0) {
        commit('SET_DIALOG_UPLOAD_WIZARD', false)
        return
      }

      commit('SET_FILES', aux)
      commit('SET_SELECTED_ITEMS', selected)
      commit('SET_CURRENT_ITEM', {
        nombre: selected[0].nombre,
        descripcion: selected[0].descripcion,
        clave: selected[0].clave,
        tipoDocumento: selected[0].tipoDocumento,
        folder: selected[0].folder,
        fechaExpiracion: selected[0].fechaExpiracion
      })
    },
    updateFields({ commit, state }, file) {
      let newFiles = _.map(state.files, function(f) {
        return f.nombre === file.nombre
          ? {
              id: f.id,
              nombre: f.nombre,
              descripcion: 'descripcion' in file ? file.descripcion : f.descripcion,
              clave: 'clave' in file ? file.clave : f.clave,
              tipoDocumento: 'tipoDocumento' in file ? file.tipoDocumento : f.tipoDocumento,
              numeroPaginas: f.numeroPaginas,
              tipo: f.tipo,
              tamanio: f.tamanio,
              hash: f.hash,
              fileData: f.fileData,
              presignUrl: f.presignUrl,
              uploaded: false,
              folder: 'folder' in file ? file.folder : f.folder,
              fechaExpiracion: 'fechaExpiracion' in file ? file.fechaExpiracion : f.fechaExpiracion
            }
          : f
      })

      commit('SET_FILES', newFiles)
    },
    updateDefaultFolder({ commit, state }, folder) {
      if (state.files.length > 0) {
        let newFiles = _.map(state.files, function(f) {
          return {
            id: f.id,
            nombre: f.nombre,
            descripcion: f.descripcion,
            clave: f.clave,
            tipoDocumento: f.tipoDocumento,
            numeroPaginas: f.numeroPaginas,
            tipo: f.tipo,
            tamanio: f.tamanio,
            hash: f.hash,
            fileData: f.fileData,
            presignUrl: f.presignUrl,
            uploaded: false,
            folder: folder,
            fechaExpiracion: f.fechaExpiracion
          }
        })

        if (newFiles.length > 0) {
          const item = newFiles[0]
          let selected = []
          selected.push(item)
          commit('SET_SELECTED_ITEMS', selected)
          commit('SET_CURRENT_ITEM', {
            nombre: item.nombre,
            descripcion: item.descripcion,
            clave: item.clave,
            tipoDocumento: item.tipoDocumento,
            folder: item.folder,
            fechaExpiracion: item.fechaExpiracion
          })
        }
        commit('SET_FILES', newFiles)
      }
    },
    async getUploadPresignUrls({ dispatch, state }) {
      const service = new S3Service()

      try {
        const { data } = await service.postPresignUrl(state.files)
        const respuesta = data

        if (respuesta.success) {
          const presignUrls = respuesta.data.presigned_urls
          const total = presignUrls.length || 0

          for (let index = 0; index < total; index++) {
            const presignedUrl = presignUrls[index]
            const nombre = presignedUrl.fields['x-amz-meta-Name']

            dispatch('updatePresignUrl', { nombre, presignedUrl })
          }

          return {
            success: true,
            errorMessage: ''
          }
        }
      } catch (err) {
        let errorMessage = ''
        if (err.response.status === 500) {
          errorMessage =
            'Ocurrio un error y el servidor no pudo subir los archivos a firmar.'
        } else {
          errorMessage = err.response.data.error.message
        }
        return {
          success: false,
          errorMessage
        }
      }
    },
    updatePresignUrl({ commit, state }, { nombre, presignedUrl }) {
      let newFiles = _.map(state.files, function(f) {
        return f.nombre === decodeURIComponent(nombre)
          ? {
              ...f,
              presignUrl: presignedUrl
            }
          : f
      })

      commit('SET_FILES', newFiles)
    },
    async uploadToS3({ state }) {
      const service = new S3Service()
      let uploadAll = true

      try {
        for (let index = 0; index < state.files.length; index++) {
          const resp = await service.postUploadFile(state.files[index])
          const success = resp.status === 204
          state.files[index].uploaded = success
          uploadAll = uploadAll && success
        }

        return {
          success: uploadAll,
          errorMessage: ''
        }
      } catch (err) {
        let errorMessage = ''
        if (err.response.status === 500) {
          errorMessage =
            'Ocurrio un error y el servidor no pudo subir los archivos a firmar.'
        } else {
          errorMessage = err.response.data.error.message
        }
        return {
          success: false,
          errorMessage
        }
      }
    },
    setSelectedItems({ commit }, selectedItems) {
      commit('SET_SELECTED_ITEMS', selectedItems)
    },
    setCurrentItem({ commit }, currentItem) {
      commit('SET_CURRENT_ITEM', currentItem)
    },
    setIsValidStepOne({ commit }, isValidStepOne) {
      commit('SET_IS_VALID_STEP_ONE', isValidStepOne)
    },
    setExpirationDate({ commit }, date) {
      commit('SET_EXPIRATION_DATE', date)
    },
    defaultFolderHasSet({ commit }) {
      commit('SET_IS_SET_DEFAULT_FOLDER', true)
    }
  },
  getters: {
    dialogUploadWizard(state) {
      return state.dialogUploadWizard
    },
    steps(state) {
      return state.steps
    },
    wizardLength(state) {
      return state.steps.length
    },
    //canGoNext(state, getters, rootState, rootGetters)
    canGoNext(state, getters, rootState) {
      switch (state.step) {
        case 1:
          return state.isValidStepOne
        case 2:
          return rootState.signersStore.signers.length > 0 && !rootState.signersStore.addSignerVisible
        case 3:
          return true
      }
    },
    wizardStep(state) {
      return state.step
    },
    files(state) {
      return state.files
    },
    fileHeaders(state) {
      return state.fileHeaders
    },
    isUploading(state) {
      return state.isUploadingFile
    },
    selectedItems(state) {
      return state.selectedItems
    },
    tipoDocumentos(state) {
      return state.tipoDocumentos
    },
    currentItem(state) {
      return state.currentItem
    },
    isValidStepOne(state) {
      return state.isValidStepOne
    },
    isSetDefaultFolder(state) {
      return state.isSetDefaultFolder
    },
    expirationDate(state) {
      return state.expirationDate
    }
  }
}
